<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vHGZdO/tc-custom/9781439664384.jpg?1704717799646" alt="This image is the cover for the book Hidden History of Boston"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden History of Boston
      </h1>
      <p class="bookDescription body article font2">
        <b>Quirky and little-known true stories of one of America’s most historic cities.</b><br/>  <br/> Boston may play a big role in American history textbooks, but it also has quite a bit of forgotten past. For example, during the colonial era, riotous mobs celebrated their hatred of the pope in an annual celebration called Pope’s Night. In 1659, Christmas was made illegal, a ban by the Puritans that remained in effect for twenty-two years. William Monroe Trotter published the <i>Boston Guardian</i>, an independent African American newspaper, and was a beacon of civil rights activism at the turn of the century. And in more recent times, a centuries-long turf war played out on the streets of quiet Chinatown, ending in the massacre of five men in a back alley in 1991.<br/>  <br/> Author and historian Dina Vargo shines a light into the cobwebbed corners of Boston’s hidden history in this riveting read, complete with illustrations.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dina Vargo
      </h2>
      
      <p class="authorDescription body article">Dina Vargo has been a lover of history and tricorn hats since dressing up at the age of six as Betsy Ross for our nation's bicentennial. After receiving her BA in fine arts from the University of Pittsburgh, she worked for the Pittsburgh History & Landmarks Foundation and as an archivist for the Rivers of Steel National Heritage Area. Dina also holds an MPA in public administration from the University of Pittsburgh and currently works in the affordable housing field. After moving to the Boston area, she became a volunteer docent for Boston by Foot, where she developed an interest for writing off-beat walking tours, and published her first book, Wild Women of Boston: Mettle and Moxie in the Hub, also with The History Press. She currently resides in Roslindale, Massachusetts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32cf9166